/* eslint-disable import/no-anonymous-default-export */
import { MissionTypeList } from './list/MissionTypeList';
import type { MissionType } from '@wwf/sdk';

export default {
    list: MissionTypeList,
    recordRepresentation: (record: MissionType) =>
        record.name ?? record.id ?? '',
};
